<template>
  <div class="cart">

    <div class="cart-data" v-if="showWidget">

      <div class="cart-overview-title">
        <div class="container">
          <strong>{{ $t("ui.cart.order") }}</strong>
        </div>
      </div>

      <div class="container">

        <div class="cart-totals">

          <div class="cart-overview">

            <strong v-if="getTotals() > 0">Totaal: {{ getTotals() }}</strong>
            <span v-if="getSize() > 0">
              {{ $t("ui.cart.items") }}: {{ getSize() }}
            </span>

            <span v-else class="empty">{{ $t("ui.cart.empty") }}</span>

            <a href="#" @click.prevent="cart()" v-if="getTotals() > 0">
              {{ $t("ui.index.catalog.view") }}
              <i class="fa fa-fw fa-angle-right" />
            </a>

          </div>

        </div>

      </div>

      <div class="cart-actions">

        <div class="container">
            <div class="row">
            <div class="col-md-5">
              <button @click.prevent="restart">{{ $t("ui.index.catalog.cancel") }}</button>
            </div>
            <div class="col-md-5">
              <button @click.prevent="cart()" :disabled="getSize() <= 0">{{ $t("ui.index.catalog.complete") }}</button>
            </div>
            <div class="col-md-2">
              <button @click.prevent="handicap()">
                <i class="fa fa-fw fa-wheelchair" />
              </button>
            </div>
          </div>
        </div>

      </div>

    </div>

    <div class="cart-contents" v-if="showCart">

      <div class="cart-processing" v-if="processing">

        <div class="cart-loading">
          <img src="/img/components/cart/spinner.svg" />
        </div>

        <p>
          {{ $t("ui.order.processing") }}
        </p>


      </div>
      <div v-else>

        <div v-if="screen === 'overview'">

          <div class="container">

            <div class="cart-head">

              <h2>{{ $t("ui.cart.order") }}</h2>

            </div>

            <div class="cart-items" v-if="getCart.length > 0">

              <ul>
                <li
                  v-for="(item, index) in getCart"
                  :key="index"
                >

                  <div class="cart-item">

                    <div class="row">
                      <div class="col-md-3">
                        <div class="image">
                          <img :src="getCartItem(item.productId).thumb" />
                        </div>
                      </div>
                      <div class="col-md-9">
                        <div class="description">

                          <strong>{{ getCartItem(item.productId).name }}</strong>
                          <p>{{ getPrice(item) }}</p>

                          <div class="options" v-if="Object.keys(item.options).length > 0">

                            <ul>
                              <li v-for="(option, index) in item.options" v-if="getProductOptionName(index).toLowerCase() !== 'personalisation'" :key="index">
                                <strong>
                                  {{ getProductOptionName(index) }}
                                </strong>
                                <div v-if="typeof(option) === 'string'">
                                  {{ getProductOptionValueName(index, option) }}
                                </div>
                                <div v-else>
                                  <span v-for="option_single in option">
                                    {{ getProductOptionValueName(index, option_single) }}
                                    &nbsp;
                                  </span>
                                </div>
                              </li>
                            </ul>

                          </div>

                          <div
                            class="personalisations"
                            v-for="(option, index) in item.options"
                            v-if="getProductOptionName(index).toLowerCase() === 'personalisation'"
                            :key="index"
                          >
                            <strong>Personalisaties:</strong>
                            <span v-for="option_single in option">
                              <i class="fa fa-fw fa-caret-right" />
                              {{ getProductOptionValueName(index, option_single) }}
                            </span>
                          </div>

                          <div class="row">
                            <div class="col-md-8 text-right">
                              <div class="amount">
                                <button @click.prevent="update(index, '-')" v-if="item.amount > 1">
                                  <i class="fa fa-fw fa-minus" />
                                </button>
                                <button @click.prevent="update(index, '-')" v-else disabled>
                                  <i class="fa fa-fw fa-minus" />
                                </button>
                                <p>{{ item.amount }}</p>
                                <button @click.prevent="update(index, '+')">
                                  <i class="fa fa-fw fa-plus" />
                                </button>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <button @click.prevent="remove(index)">
                                {{ $t("ui.cart.remove") }}
                              </button>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>

                  </div>

                </li>
              </ul>

              <button class="cart-clear" @click="clear">
                <i class="fa fa-fw fa-trash" />
                {{ $t("ui.cart.clear") }}
              </button>

            </div>

            <div class="cart-items" v-else>
              <p class="cart-items-empty">
                {{ $t("ui.cart.no_product") }}
              </p>
            </div>

          </div>

          <div class="cart-actions">

            <div class="container">

              <p class="cart-actions-total">
                {{ $t("ui.cart.amount") }}: &nbsp; {{ getTotals() }}
              </p>

              <div class="row" v-if="getSize() > 0">

                <div class="col-md-6">
                  <button @click.prevent="showCart = false">
                    {{ $t("ui.cart.back") }}
                  </button>
                </div>

                <div class="col-md-6">
                  <button @click.prevent="screen = 'request'" v-if="!pay_afterwards">
                    {{ $t("ui.cart.checkout") }}
                  </button>
                  <button @click.prevent="checkout('live')" v-else>
                    {{ $t("ui.cart.checkout") }}
                  </button>
                </div>

              </div>

              <div class="row" v-else>

                <div class="col-md-12">
                  <button @click.prevent="showCart = false">
                    {{ $t("ui.cart.back") }}
                  </button>
                </div>

              </div>

            </div>

          </div>

        </div>

        <div v-if="screen === 'request'">

          <div class="container">

            <div class="cart-head">

              <h2>{{ $t("ui.cart.voucher.title") }}</h2>

            </div>

            <div class="cart-voucher">

              <p>
                {{ $t("ui.cart.voucher.message") }}
              </p>

              <div class="buttons-big">

                <button @click.prevent="screen = 'voucher'">
                  <strong>{{ $t("ui.cart.voucher.yes.title") }}</strong>
                  {{ $t("ui.cart.voucher.yes.message") }}
                </button>

                <button @click.prevent="checkout('live')">
                  <strong>{{ $t("ui.cart.voucher.no.title") }}</strong>
                  {{ $t("ui.cart.voucher.no.message") }}
                </button>

              </div>

              <div class="buttons" style="margin-top: 50px;">
                <button @click.prevent="back()">
                  {{ $t("ui.cart.back") }}
                </button>
              </div>

            </div>

          </div>

        </div>

        <div v-if="screen === 'voucher'">

          <div class="cart-voucher">

            <div class="container">

              <Scanner />

              <div class="buttons">

                <button @click.prevent="checkout('live')">
                  {{ $t("ui.cart.voucher.scanner.skip") }}
                </button>

              </div>

            </div>

          </div>

        </div>

        <div v-if="screen === 'draft'">

          <div class="container">

            <div class="cart-head">

              <h2>{{ $t("ui.cart.discount.title") }}</h2>

            </div>

            <div class="cart-items">

              <div class="cart-discount" v-if="getOrder.receipt.Receipt.HasDiscount">
                <strong>{{ $t("ui.cart.discount.success.title") }}</strong>
                {{ getOrder.receipt.Receipt.DiscountDescription }}
              </div>
              <div class="cart-discount" v-else>
                <strong>{{ $t("ui.cart.discount.failure.title") }}</strong>
                {{ $t("ui.cart.discount.failure.message") }}
              </div>

              <ul>
                <li v-for="line in getOrder.receipt.Receipt.Lines">
                  <div class="cart-item">
                    <div class="row">
                      <div class="col-md-3">
                        <div class="image">
                          <img :src="getProductItem(line.ArticleId).thumb">
                        </div>
                      </div>
                      <div class="col-md-9">
                        <div class="description">
                          <strong>
                            {{ getProductItem(line.ArticleId).name }}
                          </strong>
                          <p>
                            <b>{{ (line.NetPriceInclVAT / 100).toFixed(2) }}</b> - {{ line.Quantity }}x
                            <br />
                            <div class="cart-draft-options" v-if="line.ArticleOptions.length > 0">
                              <span v-for="article_option in line.ArticleOptions" v-if="getProductItem(article_option.Id) !== null">
                                {{ getProductItem(article_option.Id).name }} ({{ (article_option.NetPriceInclVAT / 100).toFixed(2) }})
                              </span>
                            </div>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

          </div>

          <div class="cart-actions">

            <div class="container">

              <p class="cart-actions-total">
                {{ $t("ui.cart.amount") }}: &nbsp; {{ (getOrder.receipt.TotalAmountInclVAT / 100).toFixed(2) }}
              </p>

              <div class="row">

                <div class="col-md-6">
                  <!-- <button @click.prevent="back()">
                    {{ $t("ui.cart.back") }}
                  </button> -->
                </div>

                <div class="col-md-6">
                  <button @click.prevent="checkout('live')">
                    {{ $t("ui.cart.checkout") }}
                  </button>
                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>
</template>

<style lang="scss">

  .cart {

    position: fixed;
    background: var(--color-primary);
    width: 100%;
    height: 0;
    bottom: 0;

    .cart-data {

      position: fixed;
      background: #fff;
      bottom: 0;
      width: 100%;
      height: 350px;
      z-index: 1;

      .cart-overview-title {

        background: var(--color-primary);

        strong {

          color: #fff;
          display: block;
          padding: 12.5px 0;
          font-size: 24px;
          text-transform: uppercase;

        }

      }

      .cart-totals {

        display: block;
        margin: 25px 0;
        width: 100%;
        height: 125px;

        img {

          height: 44px;
          width: auto;
          display: inline-block;

        }

        .cart-overview {

          width: 100%;
          padding: 42.5px 0;

          strong {

            font-size: 38px;
            line-height: 38px;
            vertical-align: middle;
            margin-right: 20px;

          }

          span {

            font-size: 30px;
            line-height: 38px;
            display: inline-block;
            vertical-align: middle;

            &.empty {

              display: block;
              font-size: 20px;
              font-style: italic;
              text-align: center;

            }

          }

          a {

            float: right;
            padding: 5px 0;
            font-size: 26px;
            text-transform: uppercase;
            text-decoration: none;
            font-weight: 600;
            color: inherit;

          }

        }

      }

      .cart-actions {

        background: var(--color-background);
        padding: 25px 0;

        button {

          background: var(--color-primary);
          color: var(--color-light);
          padding: 15px 0;
          font-size: 22px;
          border-bottom: 5px solid rgba(0, 0, 0, 0.15);
          border-radius: 10px;

          &:disabled {

            opacity: 0.5;

          }

        }

      }

    }

    .cart-contents {

      position: fixed;
      background: var(--color-overlay);
      top: 100px;
      left: 0;
      width: 100%;
      height: calc(100% - 100px);
      padding: 65px 0 25px;
      animation-name: slideIn;
      animation-iteration-count: 1;
      animation-timing-function: cubic-bezier(0.65, 0.65, 0.3, 1);
      animation-duration: 1s;
      z-index: 1;

      .cart-head {

        margin: 50px 0 85px;

        h2 {

          display: block;
          text-align: center;
          text-transform: uppercase;
          color: var(--color-light);
          margin: 0;
          line-height: 60px;
          font-size: 60px;
          font-weight: 700;

        }

        .back {

          display: inline-block;
          cursor: pointer;

          button {

            background: var(--color-primary);
            display: inline-block;
            color: var(--color-light);
            padding: 0;
            font-size: 36px;
            width: 58px;
            line-height: 55px;
            border-bottom: 5px solid rgba(0, 0, 0, 0.15);

          }

          span {

            display: inline;
            font-size: 24px;
            text-transform: uppercase;
            font-weight: 600;
            margin-left: 20px;
            color: var(--color-light);

          }

        }

      }

      .cart-items {

        height: calc(100vh - 550px);
        overflow-y: scroll;

        ul {

          list-style: none;
          margin: 0;
          padding: 0;

          li {

            margin-bottom: 15px;

            &:last-child {

              margin-bottom: 0;

            }

          }

        }

        .cart-item {

          background: var(--color-light);
          padding: 20px 25px;
          height: auto;
          min-height: 100px;
          border-radius: 10px;

          .image {

            position: relative;
            width: 100%;
            height: 100%;
            overflow: hidden;

            img {

              position: absolute;
              display: block;
              width: calc(100% - 25px);
              top: 50%;
              transform: translate(12.5px, -50%);

            }

          }

          .description {

            strong {

              font-size: 24px;
              text-transform: uppercase;
              margin: 5px 0 10px;
              display: block;

            }

            p {

              font-size: 28px;

            }

            button {

              background: var(--color-primary);
              display: inline-block;
              color: var(--color-light);
              padding: 0;
              width: 100%;
              line-height: 48px;
              border-bottom: 5px solid rgba(0, 0, 0, 0.15);

            }

            .amount {

              text-align: right;

              button {

                width: 52px;
                height: 52px;
                line-height: 56px;
                font-size: 28px;

                &:disabled {

                  opacity: 0.5;

                }

              }

              p {

                display: inline-block;
                font-size: 34px;
                font-weight: 700;
                margin: 0;
                width: 75px;
                text-align: center;
                vertical-align: middle;

              }

            }

            .options {

              margin-bottom: 20px;
              border-radius: 10px;

              ul {

                list-style: none;
                margin: 0;
                padding: 0;

                li {

                  background: var(--color-background);
                  display: inline-block;
                  padding: 7.5px 25px;
                  margin-right: 15px;
                  margin-bottom: 0;
                  text-transform: capitalize;
                  text-align: center;
                  color: rgba(0, 0, 0, 0.65);
                  border-radius: 5px;

                  strong {

                    font-weight: 500;
                    font-size: 18px;
                    text-transform: uppercase;
                    margin: 0;
                    color: #222;
                    display: block;

                  }

                }

              }

            }

            .personalisations {

              background: var(--color-background);
              padding: 15px 25px;
              margin-bottom: 25px;
              border-radius: 5px;

              strong {

                font-size: 20px;
                font-weight: 500;

              }

              span {

                color: rgba(0, 0, 0, 0.65);
                display: block;

              }

            }

          }

        }

        .cart-items-empty {

          display: block;
          text-align: center;
          font-size: 22px;
          color: rgba(255, 255, 255, 0.8);
          margin-top: 100px;

        }

        .cart-draft-options {

          width: 100%;
          display: block;
          margin-top: 15px;

          span {

            background: var(--color-background);
            display: block;
            padding: 10px 15px;
            margin: 10px 0;
            margin-bottom: 0;
            text-align: left;
            color: rgba(0, 0, 0, 0.65);
            border-radius: 5px;

          }

        }

        .cart-discount {

          background: var(--color-light);
          padding: 35px 25px;
          height: auto;
          text-align: center;
          font-size: 22px;
          margin-bottom: 15px;
          border-radius: 10px;

          strong {

            display: block;
            font-size: 32px;
            margin-bottom: 15px;

          }

        }

        .cart-clear {

          background: var(--color-primary);
          display: block;
          color: var(--color-light);
          width: 350px;
          margin: 50px auto;
          padding: 15px 0;
          border-bottom: 5px solid rgba(0, 0, 0, 0.15);

        }

      }

      .cart-actions {

        background: transparent;
        padding: 25px 0;

        .cart-actions-total {

          font-size: 24px;
          color: #fff;
          text-align: right;
          margin-bottom: 25px;

        }

        button {

          background: var(--color-primary);
          color: var(--color-light);
          padding: 15px 0;
          font-size: 22px;
          border-bottom: 5px solid rgba(0, 0, 0, 0.15);
          border-radius: 10px;

        }

      }

    }

    .cart-checkout {

      padding: 15px 0;

      button {

        background: var(--color-primary);
        color: var(--color-light);
        padding: 15px 0;
        font-size: 22px;
        border-bottom: 5px solid rgba(0, 0, 0, 0.15);

        &.glowing {

          animation: glowing 2s infinite;

        }

      }

    }

    .cart-processing {

      width: 100%;
      text-align: center;
      animation-name: fadeIn;
      animation-iteration-count: 1;
      animation-timing-function: ease-in;
      animation-duration: 0.25s;

      .cart-loading {

        margin: 100px 0 50px;

        img {

          height: 128px;
          width: 128px;

        }

      }

      p {

        display: block;
        text-align: center;
        font-size: 22px;
        color: rgba(255, 255, 255, 0.8);

      }

    }

    .cart-voucher {

      p {

        display: block;
        text-align: center;
        font-size: 26px;
        margin: 0 auto 100px;
        width: 650px;
        color: #fff;

      }

      .buttons {

        width: 100%;

        button {

          background: var(--color-primary);
          color: var(--color-light);
          padding: 15px 0;
          font-size: 22px;
          border-bottom: 5px solid rgba(0, 0, 0, 0.15);
          border-radius: 10px;

        }

      }

      .buttons-big {

        width: 100%;
        display: inline-flex;

        button {

          background: var(--color-primary);
          color: var(--color-light);
          display: inline-block;
          width: calc(50% - 25px);
          height: auto;
          padding: 50px 25px;
          margin: 25px 0;
          font-size: 26px;
          border-bottom: 5px solid rgba(0, 0, 0, 0.15);
          border-radius: 10px;

          &:first-child {

            margin-right: 50px;

          }

          strong {

            display: block;
            font-size: 58px;
            margin-bottom: 25px;

          }

        }

      }

    }

  }

  @keyframes glowing {
    0% { box-shadow: 0; }
    50% { box-shadow: 0 0 10px rgba(200, 200, 200, 0.5); }
    100% { box-shadow: 0; }
  }

</style>

<script>
import { mapGetters } from "vuex";

import { CART_UPDATE, CART_CLEAR, CART_REMOVE, SET_ALERTS, SET_PROPS } from '@/store/mutations.type';

import { FETCH_PRODUCTS, CREATE_ORDER } from "@/store/actions.type";

import Scanner from "@/components/Scanner";

export default {
  name: "Cart",
  components: {
    Scanner
  },
  data() {
    return {
      showCart: false,
      showWidget: true,
      enableHandicap: false,
      receipt: {},
      screen: 'overview',
      processing: false,
      pay_afterwards: false
    };
  },
  methods: {
    getTotals() {
      let total = 0;
      this.getCart.forEach((item) => {
        total = (total + this.getPrice(item, false));
      });
      return total.toFixed(2);
    },
    getSize() {
      let size = 0;
      this.getCart.forEach((item) => {
        size = (size + item.amount);
      });
      return size;
    },
    getPrice(item, format = true) {
      let price = 0;
      let replacementPrice = false;
      let optionsPrice = 0;
      let relationsPrice = 0;
      if (Object.keys(item.options).length > 0) {
        let optionPrice = 0;
        Object.keys(item.options).forEach((index) => {
          if (typeof(item.options[index]) !== 'object') {
            optionPrice = parseFloat(this.getProductOptionValuePrice(index, item.options[index]));
            if (optionPrice > 0) {
              if (this.getProductOptionValueReplacement(index, item.options[index])) {
                if (!replacementPrice) {
                  replacementPrice = optionPrice;
                }
              }
              else {
                optionsPrice = (optionsPrice + optionPrice);
              }
            }
          }
          else {
            Object.keys(item.options[index]).forEach((subindex) => {
              optionPrice = parseFloat(this.getProductOptionValuePrice(index, item.options[index][subindex]));
              if (optionPrice > 0) {
                optionsPrice = (optionsPrice + optionPrice);
              }
            });
          }
        });
      }
      let productPrice = this.getCartItem(item.productId).price.replace(/,(?=.*\.\d+)/g, '');
      productPrice = parseFloat(productPrice.substr(1).replace(',', '.'));
      if (replacementPrice !== false) {
        price = replacementPrice;
      }
      else {
        price = productPrice;
      }
      let productRelations = this.getCartItem(item.productId).related;
      if (productRelations.length > 0) {
        Object.keys(productRelations).forEach((index) => {
          let relation = productRelations[index];
          relationsPrice = parseFloat(relation.price.substr(1).replace(',', '.'));
        });
      }
      price = ((parseFloat(price) + optionsPrice + relationsPrice) * item.amount);
      price = (format === true ? price.toFixed(2) : price);
      return price;
    },
    update(product, method) {
      this.$store.commit(CART_UPDATE, {
        product: product,
        method: method
      });
    },
    checkout(type) {
      if (this.getSize() > 0) {

        let data = false;

        this.$store.commit(SET_PROPS, {
          handicap: false
        });

        this.processing = true;

        switch (type) {
          case 'draft':
            data = {
              receipt: 'draft',
              terminal: false
            };
            break;
          case 'live':
            data = {
              receipt: 'live',
              terminal: !this.pay_afterwards
            };
            break;
        }

        this.$store.dispatch(CREATE_ORDER, data).then((order) => {
          if (data.receipt === 'live') {
            this.$router.push({
              name: 'checkout'
            });
          }
          else {
            this.processing = false;
            this.receipt = order;
            this.screen = 'draft';
          }
        }).catch(() => {
        });
      }
      else {
        this.$store.commit(SET_ALERTS, {
          type: 'regular',
          title: this.$i18n.t("alerts.items.cart_empty.title"),
          message: this.$i18n.t("alerts.items.cart_empty.message")
        });
      }
    },
    remove(index) {
      this.$store.commit(CART_REMOVE, {
        index: index
      });
    },
    handicap() {
      this.enableHandicap = !this.enableHandicap;
      this.$store.commit(SET_PROPS, {
        handicap: this.enableHandicap
      });
    },
    cart() {
      // this.$store.commit(SET_PROPS, {
      //   handicap: false
      // });
      this.showCart = !this.showCart;
    },
    back() {
      this.showCart = false;
      this.screen = 'overview';
    },
    restart() {
      this.$store.commit(SET_ALERTS, {
        type: 'regular',
        title: this.$i18n.t("alerts.items.abort_order.title"),
        message: this.$i18n.t("alerts.items.abort_order.message"),
        action: {
          key: 'abort',
          text: this.$i18n.t("alerts.items.abort_order.button")
        }
      });
    },
    clear() {
      this.$store.commit(SET_ALERTS, {
        type: 'regular',
        title: this.$i18n.t("alerts.items.clear_order.title"),
        message: this.$i18n.t("alerts.items.clear_order.message"),
        action: {
          key: 'clear',
          text: this.$i18n.t("alerts.items.clear_order.button")
        }
      });
    }
  },
  created() {
    let interval = false;
    if (!interval) {
      interval = window.setInterval(() => {
        if (this.getProps.receipt === 'create') {
          this.checkout('draft');
          clearInterval(interval);
          this.interval = false;
        }
      }, 100);
    }
    this.pay_afterwards = this.getConfig.pay_afterwards;
  },
  computed: {
    ...mapGetters([
      'getProps',
      'getCart',
      'getConfig',
      'getOrder',
      'getCartItem',
      'getProductItem',
      'getProductOptionName',
      'getProductOptionValueName',
      'getProductOptionValuePrice',
      'getProductOptionValueReplacement',
      'getProducts'
    ])
  }
};
</script>
